module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', [_c('el-descriptions', {
    attrs: {
      "border": true,
      "column": 3,
      "title": "基本信息"
    }
  }, [_c('template', {
    slot: "extra"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "gap": "10px"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.$router.back()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  }), _vm._v("返回\r\n          ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-position"
    },
    on: {
      "click": _vm.address
    }
  }, [_vm._v("地址管理")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-edit"
    },
    on: {
      "click": _vm.handleEdit
    }
  }, [_vm._v("客户编辑")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-bank-card"
    },
    on: {
      "click": _vm.placeOrder
    }
  }, [_vm._v("创建订单")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-notebook-1"
    },
    on: {
      "click": _vm.underway
    }
  }, [_vm._v("客户跟进")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "perm",
      rawName: "v-perm",
      value: ('customMycustom/del'),
      expression: "'customMycustom/del'"
    }],
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.handleDel
    }
  }, [_c('i', {
    staticClass: "el-icon-delete"
  }), _vm._v("客户删除\r\n          ")])], 1)]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "公司"
    }
  }, [_vm._v(_vm._s(_vm.showForm.companyName))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "客户姓名"
    }
  }, [_vm._v(_vm._s(_vm.showForm.customerName))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "归属人"
    }
  }, [_vm._v(_vm._s(_vm.showForm.salesMan.adminName))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "客户微信"
    }
  }, [_vm._v(_vm._s(_vm.showForm.customerWx))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "手机号"
    }
  }, [_vm._v(_vm._s(_vm.formattedPhoneNumber))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "电话号"
    }
  }, _vm._l((_vm.showForm.telPhone), function(phone, index) {
    return _c('span', {
      key: index,
      staticStyle: {
        "margin-right": "8px"
      }
    }, [_vm._v("\r\n      " + _vm._s(phone) + "\r\n    ")])
  }), 0), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "所属地区"
    }
  }, [_vm._v(_vm._s(_vm.showForm.area))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "详细地址"
    }
  }, [_vm._v(_vm._s(_vm.showForm.address))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "录入时间"
    }
  }, [_vm._v(_vm._s(_vm.showForm.entryCustomerTime))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "修改时间"
    }
  }, [_vm._v(_vm._s(_vm.showForm.updateTime))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "客户销售渠道"
    }
  }, [_vm._v(_vm._s(_vm.showForm.type.customerType))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "客户级别"
    }
  }, [_vm._v(_vm._s(_vm.showForm.label.customerLabel))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "客户来源"
    }
  }, [_vm._v(_vm._s(_vm.showForm.source.customerSource))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "累计成交次数"
    }
  }, [_vm._v(_vm._s(_vm.showForm.totalDealCount) + " 次")]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "下单产品数量"
    }
  }, [_vm._v(_vm._s(_vm.showForm.orderProductCount) + " 箱")]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "累计金额"
    }
  }, [_vm._v(_vm._s(_vm.showForm.totalAmount) + " 元")]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "最近下单时间"
    }
  }, [_vm._v(_vm._s(_vm.showForm.lastDealTime))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "备注信息",
      "span": 3
    }
  }, [_c('div', {
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }, [_vm._v(_vm._s(_vm.showForm.notes))])]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "客户图片",
      "span": 3
    }
  }, _vm._l((_vm.showForm.picture), function(url, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "display": "inline-block",
        "margin-right": "10px"
      }
    }, [_c('el-image', {
      staticStyle: {
        "width": "120px",
        "height": "120px",
        "border-radius": "6px",
        "box-shadow": "0 2px 4px rgba(0,0,0,0.1)"
      },
      attrs: {
        "src": url,
        "fit": "cover",
        "preview-src-list": _vm.showForm.picture
      }
    })], 1)
  }), 0)], 2), _vm._v(" "), _c('h3', [_vm._v("\r\n      订单记录\r\n")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.acquisitionOrders,
      "highlight-current-row": "",
      "border": "",
      "max-height": "500"
    },
    on: {
      "expand-change": _vm.handleExpandChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "padding-left": "10px"
          }
        }, [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": props.row.products,
            "stripe": ""
          }
        }, [_c('el-table-column', {
          attrs: {
            "prop": "productName",
            "align": 'center',
            "label": "产品名称"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "productImage",
            "align": 'center',
            "label": "产品图片"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-image', {
                staticStyle: {
                  "width": "100px",
                  "height": "100px"
                },
                attrs: {
                  "src": scope.row.picture,
                  "fit": "cover"
                }
              })]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "price",
            "align": 'center',
            "label": "产品价格"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "costPrice",
            "align": 'center',
            "label": "售价"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "salePrice",
            "align": 'center',
            "label": "成交价"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "orderNum",
            "align": 'center',
            "label": "成交数量"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "orderAmount",
            "align": 'center',
            "label": "金额"
          }
        })], 1)], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderSn",
      "label": "订单号",
      "width": "150",
      "header-align": 'center',
      "align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "color": "red"
          },
          on: {
            "click": function($event) {
              return _vm.handlePass(scope.row.orderSn)
            }
          }
        }, [_vm._v(_vm._s(scope.row.orderSn))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "employee.adminName",
      "label": "归属人",
      "header-align": 'center',
      "align": 'center'
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderAmount",
      "label": "订单金额",
      "sortable": "",
      "header-align": 'center',
      "align": 'center'
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "payType",
      "label": "支付方式",
      "header-align": 'center',
      "align": 'center'
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "下单时间",
      "header-align": 'center',
      "align": 'center'
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "logisticsMethods",
      "label": "物流方式",
      "header-align": 'center',
      "align": 'center'
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "logisticsCompanies",
      "label": "物流公司",
      "header-align": 'center',
      "align": 'center'
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "trackingNumber",
      "label": "物流单号",
      "header-align": 'center',
      "align": 'center'
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderState",
      "label": "订单状态",
      "header-align": 'center',
      "align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.orderState == 3) ? _c('span', {
          staticStyle: {
            "color": "orange"
          }
        }, [_vm._v("待发货")]) : _vm._e(), _vm._v(" "), (scope.row.orderState == 4) ? _c('span', {
          staticStyle: {
            "color": "#50bfff"
          }
        }, [_vm._v("已发货")]) : _vm._e(), _vm._v(" "), (scope.row.orderState == 5) ? _c('span', {
          staticStyle: {
            "color": "lightgreen"
          }
        }, [_vm._v("交易成功")]) : _vm._e(), _vm._v(" "), (scope.row.orderState == 6) ? _c('span', {
          staticStyle: {
            "color": "lightcoral"
          }
        }, [_vm._v("订单取消")]) : _vm._e(), _vm._v(" "), (scope.row.orderState == 0) ? _c('span', {
          staticStyle: {
            "color": "lightcoral"
          }
        }, [_vm._v("待审核")]) : _vm._e(), _vm._v(" "), (scope.row.orderState == 1) ? _c('span', {
          staticStyle: {
            "color": "lightcoral"
          }
        }, [_vm._v("待复审")]) : _vm._e(), _vm._v(" "), (scope.row.orderState == 2) ? _c('span', {
          staticStyle: {
            "color": "lightcoral"
          }
        }, [_vm._v("审核未通过")]) : _vm._e(), _vm._v(" "), (scope.row.orderState == 7) ? _c('span', {
          staticStyle: {
            "color": "lightcoral"
          }
        }, [_vm._v("待终审")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "lastOperationTime",
      "label": "最后操作时间",
      "header-align": 'center',
      "align": 'center'
    }
  })], 1), _vm._v(" "), _c('h3', [_vm._v("活跃记录")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.displayedRecords,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "回访时间",
      "prop": "date",
      "width": "200",
      "header-align": 'center',
      "align": 'center'
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "跟进记录",
      "header-align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.recordType === 1) ? _c('div', [_c('el-tooltip', {
          attrs: {
            "effect": "light",
            "content": "详情请查看上面订单记录"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_vm._v(_vm._s(scope.row.content))])], 1)], 1) : _c('div', [_c('span', {
          staticClass: "content-wrap"
        }, [_vm._v(_vm._s(scope.row.content))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作人",
      "prop": "console.adminName",
      "width": "200",
      "header-align": 'center',
      "align": 'center'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "20px"
    }
  }, [(_vm.displayedRecords.length < _vm.followUpForm.length) ? _c('el-button', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "click": _vm.loadMoreData
    }
  }, [_vm._v("\r\n        加载更多\r\n        "), (_vm.loading) ? _c('div', {
    staticClass: "loading-overlay"
  }) : _vm._e()]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "客户跟进",
      "visible": _vm.underwayVisible,
      "close-on-click-modal": false,
      "width": "45%"
    },
    on: {
      "update:visible": function($event) {
        _vm.underwayVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "showForm",
    attrs: {
      "model": _vm.showForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户跟进"
    }
  }, [_c('el-input', {
    staticClass: "input-field",
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "请输入与客户的跟进记录"
    },
    model: {
      value: (_vm.showForm.content),
      callback: function($$v) {
        _vm.$set(_vm.showForm, "content", $$v)
      },
      expression: "showForm.content"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.follow
    }
  }, [_vm._v("\r\n          添加跟进记录\r\n        ")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.underwayVisible = false
      }
    }
  }, [_vm._v("\r\n          取消\r\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": "客户编辑",
      "visible": _vm.editFormVisible,
      "size": "60%",
      "direction": "rtl"
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      },
      "close": _vm.closeEditPage
    }
  }, [_c('div', {
    staticClass: "edit-form-container"
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "130px",
      "rules": _vm.editFormRules
    }
  }, [_c('div', {
    staticClass: "form-section"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "customerName"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_vm._v("\r\n                  客户名称 "), _c('i', {
          staticClass: "el-icon-user icon-size"
        })]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入客户名称"
    },
    model: {
      value: (_vm.editForm.customerName),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "customerName", $$v)
      },
      expression: "editForm.customerName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "companyName"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_vm._v("\r\n                  公司名称 "), _c('i', {
          staticClass: "el-icon-office-building icon-size"
        })]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入公司名称"
    },
    model: {
      value: (_vm.editForm.companyName),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "companyName", $$v)
      },
      expression: "editForm.companyName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "phoneNumber"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_vm._v("手机号 "), _c('i', {
          staticClass: "el-icon-mobile-phone icon-size"
        })]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('el-input', {
    attrs: {
      "maxlength": "11",
      "show-word-limit": "",
      "auto-complete": "off",
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.editForm.phoneNumber),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "phoneNumber", $$v)
      },
      expression: "editForm.phoneNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "sourceId"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_vm._v("客户来源 "), _c('i', {
          staticClass: "el-icon-position icon-size"
        })]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择客户来源"
    },
    model: {
      value: (_vm.editForm.sourceId),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "sourceId", $$v)
      },
      expression: "editForm.sourceId"
    }
  }, _vm._l((_vm.custoSource), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.customerSource,
        "value": item.id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "labelId"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_vm._v("客户级别 "), _c('i', {
          staticClass: "el-icon-star-off icon-size"
        })]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择客户级别"
    },
    model: {
      value: (_vm.editForm.labelId),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "labelId", $$v)
      },
      expression: "editForm.labelId"
    }
  }, _vm._l((_vm.custoLabel), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.customerLabel,
        "value": item.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "typeId"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_vm._v("销售渠道 "), _c('i', {
          staticClass: "el-icon-shopping-cart-full icon-size"
        })]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择销售渠道"
    },
    model: {
      value: (_vm.editForm.typeId),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "typeId", $$v)
      },
      expression: "editForm.typeId"
    }
  }, _vm._l((_vm.custoType), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.customerType,
        "value": item.id
      }
    })
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-section"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("地址信息")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "area"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_vm._v("\r\n            所属地区 "), _c('i', {
          staticClass: "el-icon-map-location icon-size"
        })]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": _vm.pcaTextArr,
      "placeholder": "请选择所属地区"
    },
    model: {
      value: (_vm.editForm.area),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "area", $$v)
      },
      expression: "editForm.area"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "address"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_vm._v("\r\n            详细地址 "), _c('i', {
          staticClass: "el-icon-location-information icon-size"
        })]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入详细地址"
    },
    model: {
      value: (_vm.editForm.address),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "address", $$v)
      },
      expression: "editForm.address"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-section"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("联系方式")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "客户电话"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_vm._v("\r\n            客户电话 "), _c('i', {
          staticClass: "el-icon-phone-outline icon-size"
        })]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('div', {
    staticClass: "phone-list"
  }, _vm._l((_vm.editForm.telPhone), function(phone, index) {
    return _c('div', {
      key: index,
      staticClass: "phone-item"
    }, [_c('el-input', {
      attrs: {
        "auto-complete": "off",
        "maxlength": "11",
        "show-word-limit": "",
        "placeholder": "请输入客户电话"
      },
      model: {
        value: (_vm.editForm.telPhone[index]),
        callback: function($$v) {
          _vm.$set(_vm.editForm.telPhone, index, $$v)
        },
        expression: "editForm.telPhone[index]"
      }
    }), _vm._v(" "), (_vm.editForm.telPhone.length > 1) ? _c('el-button', {
      attrs: {
        "type": "danger",
        "icon": "el-icon-delete",
        "circle": ""
      },
      on: {
        "click": function($event) {
          return _vm.removePhone(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), (index === _vm.editForm.telPhone.length - 1) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "icon": "el-icon-plus",
        "circle": ""
      },
      on: {
        "click": function($event) {
          return _vm.addInput(index)
        }
      }
    }) : _vm._e()], 1)
  }), 0)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注信息"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_vm._v("\r\n            备注信息 "), _c('i', {
          staticClass: "el-icon-document icon-size"
        })]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "auto-complete": "off",
      "placeholder": "请输入备注信息"
    },
    model: {
      value: (_vm.editForm.notes),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "notes", $$v)
      },
      expression: "editForm.notes"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-section"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("附件信息")]), _vm._v(" "), _c('div', {
    staticClass: "image-section"
  }, [_c('div', {
    staticClass: "image-title"
  }, [_c('i', {
    staticClass: "el-icon-picture-outline icon-size"
  }), _vm._v(" 客户图片\r\n          ")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "image-preview-container"
  }, [(_vm.editForm.picture && _vm.editForm.picture.length > 0) ? _c('div', {
    staticClass: "image-grid"
  }, _vm._l((_vm.editForm.picture), function(pic, index) {
    return _c('div', {
      key: index,
      staticClass: "image-item"
    }, [_c('el-image', {
      staticClass: "edit_show_image",
      attrs: {
        "src": pic,
        "fit": "cover"
      }
    }, [_c('div', {
      staticClass: "image-error",
      attrs: {
        "slot": "error"
      },
      slot: "error"
    }, [_vm._v("图片加载失败")])]), _vm._v(" "), _c('i', {
      staticClass: "el-icon-close delete-icon",
      on: {
        "click": function($event) {
          return _vm.deleteImage(index)
        }
      }
    })], 1)
  }), 0) : _c('div', {
    staticClass: "image-placeholder"
  }, [_vm._v("\r\n                  暂无图片\r\n                ")])]), _vm._v(" "), _c('el-upload', {
    ref: "uploadEdit",
    staticClass: "upload-demo",
    attrs: {
      "name": "file",
      "action": this.$uploadURL,
      "on-remove": _vm.handleFileRemove,
      "on-success": _vm.handleFileUploadedit,
      "on-exceed": _vm.handleFileExceed,
      "file-list": _vm.fileList,
      "limit": 5,
      "accept": ".jpg,.png,.gif,.qlv",
      "list-type": "picture"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")])], 1)], 1)], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "drawer-footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    on: {
      "click": _vm.editSubmit
    }
  }, [_vm._v("提交")])], 1)], 1)]), _vm._v(" "), _c('customer-address', {
    attrs: {
      "visible": _vm.addressVisible,
      "customer-id": _vm.customerId
    },
    on: {
      "update:visible": function($event) {
        _vm.addressVisible = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d2135f60"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/customerMag/customerDetail.vue
// module id = 1037
// module chunks = 3